export default __webpack_public_path__ + "3da284211a7caa2b9060e2bc5a0044a2.pdf";